import bus from '~/bus'
import { getEventFile } from '~/helpers/eventHelper'

export default {
  name: 'created',
  do: function (payload) {
    console.log('DEBUG created: ', this, payload)
    if ((this.fileChildren && this.fileChildren.includes(payload.parent_id))) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
    if (this.file === payload.parent_id || this.file === 'recent') {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('insertFile', response)
        this.fileChildren.push(payload.file_id)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/created.js